export default __webpack_public_path__ + "static/media/gallery_02.f2f16bc5.jpg";